// TabsNav.jsx
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./tabs.css";

export default function TabsNav({ tabs }) {
  const { t } = useTranslation("ui");
  return (
    <nav className="tabs" aria-label={t("tabsNav.ariaLabel")}>
      <ul className="tabs-list">
        {tabs.map((tab) => (
          <li key={tab.to}>
            <NavLink
              to={tab.to}
              className={({ isActive }) =>
                `tab ${isActive ? "tab--active" : ""}`
              }>
              {tab.icon && <img src={tab.icon} alt="" className="tab__icon" />}
              <span className="tab__label">{tab.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
